import { render, staticRenderFns } from "./DialogoBuscarCliente.vue?vue&type=template&id=48243e0d&scoped=true&"
import script from "./DialogoBuscarCliente.vue?vue&type=script&lang=js&"
export * from "./DialogoBuscarCliente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48243e0d",
  null
  
)

export default component.exports